import { AppState } from '../models/state/appState';

/*
 * Selects the user settings
 */
export function selectUserSettings(state: AppState) {
  return state.userSettings;
}
